import nextDynamic from "next/dynamic";

const Account = nextDynamic(() => import("./Account"), { ssr: false });
const ChainSwitcher = nextDynamic(() => import("./ChainSwitcher"), {
  ssr: false,
});
const Permissions = nextDynamic(() => import("./Permissions"), { ssr: false });
const DurationPicker = nextDynamic(() => import("./DurationPicker"), {
  ssr: false,
});
const Expected = nextDynamic(() => import("./Expected"), { ssr: false });
const AutofillCreate = nextDynamic(() => import("./AutofillCreate"), {
  ssr: false,
});
const History = nextDynamic(() => import("./History"), { ssr: false });
const Legend = nextDynamic(() => import("./Legend"), { ssr: false });
const MomentPicker = nextDynamic(() => import("./MomentPicker"), {
  ssr: false,
});
const Options = nextDynamic(() => import("./Options"), { ssr: false });
const Proxy = nextDynamic(() => import("./Proxy"), { ssr: false });
const Search = nextDynamic(() => import("./Search"), { ssr: false });
const Share = nextDynamic(() => import("./Share"), { ssr: false });
const Simulator = nextDynamic(() => import("./Simulator"), { ssr: false });
const TokenPicker = nextDynamic(() => import("./TokenPicker"), { ssr: false });
const Transaction = nextDynamic(() => import("./Transaction"), { ssr: false });
const WalletSanction = nextDynamic(() => import("./SanctionAccount"), {
  ssr: false,
});
const StreamSanction = nextDynamic(() => import("./SanctionStream"), {
  ssr: false,
});

function All() {
  return (
    <>
      <Account />
      <AutofillCreate />
      <ChainSwitcher />
      <Permissions />
      <DurationPicker />
      <Expected />
      <History />
      <Legend />
      <MomentPicker />
      <Options />
      <Search />
      <Share />
      <Simulator />
      <TokenPicker />
      <Transaction />
      <WalletSanction />
      <StreamSanction />
      <Proxy />
    </>
  );
}

const ModalCards = {
  All,
};

export default ModalCards;
